import { render, staticRenderFns } from "./FirmFeed.vue?vue&type=template&id=23420276&scoped=true"
import script from "./FirmFeed.vue?vue&type=script&lang=js"
export * from "./FirmFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23420276",
  null
  
)

export default component.exports